<template>
    <div v-if="model">
        <rkm-area no-margin-top title="Profissional">
            <rkm-row>
                <rkm-col cols="6"><rkm-form-input :value="form.usuario.nome" disabled label="Nome" /></rkm-col>
                <rkm-col cols="2"><rkm-form-input :value="form.usuario.dataNascimento" disabled label="Data de nascimento" /></rkm-col>
                <rkm-col cols="2"><rkm-form-input :value="form.usuario.cpf" disabled label="CPF" /></rkm-col>
                <rkm-col cols="2"><rkm-form-input :value="form.usuario.cns" disabled label="CNS" /></rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area title="Origem obrigatória">
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.origem.unidades"
                        @change="changeOrigemUnidade"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.origem.unidadeId"
                        value-field="id"
                    />
                    <rkm-form-select
                        :options="form.origem.infraestruturas"
                        @change="changeOrigemInfraestrutura"
                        label="Local de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="model.origem.infraestruturaId"
                        value-field="id"
                    />
                    <rkm-form-select
                        :options="form.origem.ocupacoes"
                        @change="changeOrigemOcupacao"
                        label="CBO"
                        show-default-option
                        text-field="descricao"
                        v-model="model.origem.ocupacaoId"
                        value-field="id"
                    />
                    <rkm-form-select
                        :options="form.origem.especialidades"
                        @change="changeOrigemEspecialidade"
                        label="Especialidade"
                        show-default-option
                        text-field="nome"
                        v-model="model.origem.especialidadeId"
                        value-field="id"
                    />
                </rkm-col>
                <rkm-col cols="6">
                    <rkm-calendar :items="datasCalendario" @click="selectDate" />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-form ref="operationForm" show-legend v-if="model.origem.data">
            <rkm-area :title="`Consultas reguladas de ${model.origem.data}`">
                <rkm-row>
                    <rkm-col>
                        <rkm-table :fields="fields.agendamentos" :items="form.origem.agendamentos">
                            <template v-slot:head(selecionado)>
                                <rkm-form-checkbox
                                    :value="true"
                                    @change="selectAll"
                                    v-model="todosSelecionados"
                                />
                            </template>
                            <template v-slot:cell(selecionado)="{item}">
                                <span :title="item.motivoBloqueio">
                                    <rkm-form-checkbox
                                        :disabled="!item.selecionavel"
                                        :value="true"
                                        v-model="item.selecionado"
                                    />
                                </span>
                            </template>
                            <template v-slot:cell(situacao)="{item}">
                                <span v-if="item.selecionavel" class="text-success">Disponível</span>
                                <span v-else class="text-danger">{{item.motivoBloqueio}}</span>
                            </template>
                        </rkm-table>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area title="Destino">
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-radio-group
                            :validations="{required: true}"
                            label="Reagendar para a mesma unidade e profissional?"
                            v-model="mesmoDestino"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>

                <rkm-row v-if="mesmoDestino === false">
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.destino.unidades"
                            :validations="{required: true}"
                            @change="changeDestinoUnidade"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.destino.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.destino.infraestruturas"
                            :validations="{required: true}"
                            @change="changeDestinoInfraestrutura"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.destino.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.destino.ocupacoes"
                            :validations="{required: true}"
                            @change="changeDestinoOcupacao"
                            label="CBO"
                            show-default-option
                            text-field="descricao"
                            v-model="model.destino.ocupacaoId"
                            value-field="id"
                        />
                    </rkm-col>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.destino.usuarios"
                            :validations="{required: true}"
                            @change="changeDestinoUsuario"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.destino.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row v-if="mesmoDestino !== null">
                    <rkm-col>
                        <rkm-table :fields="fields.jornadas" :items="form.destino.jornadas">
                            <template v-slot:cell(selecionada)="{item}">
                                <rkm-form-radio
                                    :disabled="!jornadaCompativel(item)"
                                    :value="item.id"
                                    name="jornada-destino"
                                    v-model="model.destino.jornadaId"
                                />
                            </template>
                            <template v-slot:cell(consultas)="{item}">
                                {{item.quantidadeConsultaAgendada}} / {{item.quantidadeConsultaTotal}}
                            </template>
                            <template v-slot:cell(retornos)="{item}">
                                {{item.quantidadeRetornoAgendada}} / {{item.quantidadeRetornoTotal}}
                            </template>
                        </rkm-table>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-textarea
                            :validations="{required: true, max: 1000}"
                            label="Motivo do reagendamento"
                            rows="4"
                            v-model="model.motivoReagendamento"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-row>
                <rkm-col class="text-right">
                    <rkm-button
                        :disabled="selected.length === 0 || !model.destino.jornadaId || submitting"
                        @click="confirmOperation"
                        color="primary"
                    >
                        Reagendar {{selected.length}} consulta(s)
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-area title="Resultado do reagendamento" v-if="resultado">
            <rkm-row>
                <rkm-col cols="3"><strong>Status:</strong> {{resultado.status}}</rkm-col>
                <rkm-col cols="3"><strong>Selecionadas:</strong> {{resultado.quantidadeSelecionada}}</rkm-col>
                <rkm-col cols="3"><strong>Reagendadas:</strong> {{resultado.quantidadeReagendada}}</rkm-col>
                <rkm-col cols="3"><strong>Não reagendadas:</strong> {{resultado.quantidadeNaoReagendada}}</rkm-col>
            </rkm-row>
            <rkm-row v-if="failedItems.length">
                <rkm-col>
                    <rkm-table :fields="fields.falhas" :items="failedItems" />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <SupervisorModal :submitting="submitting" @authorized="process" ref="supervisor" />
    </div>
</template>

<script>
import SupervisorModal from './components/supervisor/Modal'
import agendamentoTipo from '@/enums/ambulatorio/agendamentoTipo'
import {error, repository, stringCase} from '@/mixins'
import moment from 'moment'
import {mapActions} from 'vuex'

export default {
    components: {SupervisorModal},
    computed: {
        datasCalendario() {
            return this.form.origem.datas.map(item => ({
                dates: moment(item.data, 'DD/MM/YYYY'),
                highlight: 'green',
                title: `${item.quantidadeAgendada} ag.`,
                popover: `${item.quantidadeAgendada} agendamento(s) regulado(s)`,
            }))
        },
        selected() {
            return this.form.origem.agendamentos.filter(item => item.selecionavel && item.selecionado)
        },
        failedItems() {
            return this.resultado && this.resultado.itens
                ? this.resultado.itens.filter(item => item.status !== 'SUCESSO')
                : []
        },
    },
    created() {
        this.repositories = {
            reagendamentoMedico: this.getConectaSusRepository('regulacao.reagendamentoMedico'),
        }
    },
    data: () => ({
        additionals: {},
        form: null,
        model: null,
        mesmoDestino: null,
        todosSelecionados: false,
        resultado: null,
        submitting: false,
        fields: {
            agendamentos: [
                {key: 'selecionado', label: '#', class: 'col-min text-center'},
                {key: 'horario', label: 'Horário'},
                {key: 'pacienteNome', label: 'Paciente'},
                {key: 'pacienteDataNascimento', label: 'Nascimento'},
                {key: 'pacienteProntuario', label: 'Prontuário'},
                {key: 'tipoNome', label: 'Tipo'},
                {key: 'pacienteTelefone', label: 'Telefone'},
                {key: 'situacao', label: 'Situação'},
            ],
            jornadas: [
                {key: 'selecionada', label: '#', class: 'col-min text-center'},
                {key: 'data', label: 'Data'},
                {key: 'diaSemana', label: 'Dia da semana'},
                {key: 'inicio', label: 'Início'},
                {key: 'fim', label: 'Fim'},
                {key: 'consultas', label: 'Consultas'},
                {key: 'retornos', label: 'Retornos'},
            ],
            falhas: [
                {key: 'pacienteNome', label: 'Paciente'},
                {key: 'horarioOrigem', label: 'Horário de origem'},
                {key: 'solicitacaoId', label: 'Solicitação'},
                {key: 'motivoFalha', label: 'Motivo'},
            ],
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        async load() {
            this.setLoading()
            try {
                const {data} = await this.repositories.reagendamentoMedico.edit(this.id)
                this.additionals = data.additionals
                this.form = data.form
                this.model = data.model
            } catch (exception) {
                this.handleError(exception)
            } finally {
                this.unsetLoading()
            }
        },
        baseOrigem(extra = {}) {
            return this.camelObjectKeysToSnakeRecursive({...this.model.origem, ...extra})
        },
        resetFrom(level) {
            const order = ['infraestrutura', 'ocupacao', 'especialidade', 'data']
            const collections = {
                infraestrutura: 'infraestruturas',
                ocupacao: 'ocupacoes',
                especialidade: 'especialidades',
            }
            const start = order.indexOf(level)
            order.slice(start).forEach(field => {
                if (field === 'data') {
                    this.model.origem.data = null
                    this.form.origem.datas = []
                    this.form.origem.agendamentos = []
                } else {
                    this.model.origem[`${field}Id`] = null
                    this.form.origem[collections[field]] = []
                }
            })
            this.resetOperation()
        },
        async changeOrigemUnidade(value) {
            this.resetFrom('infraestrutura')
            if (!value) return
            await this.loadOrigem('infraestruturas')
        },
        async changeOrigemInfraestrutura(value) {
            this.resetFrom('ocupacao')
            if (!value) return
            await this.loadOrigem('ocupacoes')
        },
        async changeOrigemOcupacao(value) {
            this.resetFrom('especialidade')
            if (!value) return
            await this.loadOrigem('especialidades')
        },
        async changeOrigemEspecialidade(value) {
            this.model.origem.data = null
            this.form.origem.datas = []
            this.form.origem.agendamentos = []
            this.resetOperation()
            if (!value) return
            await this.loadOrigem('datas')
        },
        async loadOrigem(listar) {
            this.setLoading()
            try {
                const {data} = await this.repositories.reagendamentoMedico.list({
                    origem: 'origem',
                    listar,
                    ...this.baseOrigem(listar === 'datas' ? {data: null} : {}),
                })
                Object.keys(data).forEach(key => this.form.origem[this.snakeToCamel(key)] = data[key])
                const key = listar
                if (data[key] && data[key].length === 1 && listar !== 'datas') {
                    const singular = {infraestruturas: 'infraestruturaId', ocupacoes: 'ocupacaoId', especialidades: 'especialidadeId'}[listar]
                    this.model.origem[singular] = data[key][0].id
                    if (listar === 'infraestruturas') await this.changeOrigemInfraestrutura(data[key][0].id)
                    if (listar === 'ocupacoes') await this.changeOrigemOcupacao(data[key][0].id)
                    if (listar === 'especialidades') await this.changeOrigemEspecialidade(data[key][0].id)
                }
            } catch (exception) {
                this.handleError(exception)
            } finally {
                this.unsetLoading()
            }
        },
        snakeToCamel(value) {
            return value.replace(/_([a-z])/g, (_, char) => char.toUpperCase())
        },
        async selectDate(event) {
            const found = this.form.origem.datas.find(item => moment(item.data, 'DD/MM/YYYY').isSame(event.date, 'day'))
            if (!found) return
            this.resetOperation()
            this.model.origem.data = found.data
            await this.loadAppointments()
            await this.loadDestinoUnidades()
        },
        async loadAppointments() {
            this.setLoading()
            try {
                const {data} = await this.repositories.reagendamentoMedico.list({
                    origem: 'origem', listar: 'agendamentos', ...this.baseOrigem(),
                })
                this.form.origem.agendamentos = data.agendamentos.map(item => ({...item, selecionado: false}))
            } catch (exception) {
                this.handleError(exception)
            } finally {
                this.unsetLoading()
            }
        },
        selectAll(value) {
            this.form.origem.agendamentos.forEach(item => {
                if (item.selecionavel) item.selecionado = value
            })
        },
        destinoParams(extra = {}) {
            return {
                origem: 'destino',
                especialidadeId: this.model.origem.especialidadeId,
                dataOrigem: this.model.origem.data,
                ...extra,
            }
        },
        async loadDestinoUnidades() {
            this.setLoading()
            try {
                const {data} = await this.repositories.reagendamentoMedico.list(this.camelObjectKeysToSnakeRecursive(
                    this.destinoParams({listar: 'unidades'})
                ))
                this.form.destino.unidades = data.unidades
            } catch (exception) {
                this.handleError(exception)
            } finally {
                this.unsetLoading()
            }
        },
        async changeDestinoUnidade(value) {
            this.resetDestino('infraestrutura')
            if (!value) return
            this.setLoading()
            try {
                const {data} = await this.repositories.reagendamentoMedico.list(this.camelObjectKeysToSnakeRecursive(
                    this.destinoParams({listar: 'infraestruturas', unidadeId: value})
                ))
                this.form.destino.infraestruturas = data.infraestruturas
            } catch (exception) {
                this.handleError(exception)
            } finally {
                this.unsetLoading()
            }
        },
        async changeDestinoInfraestrutura(value) {
            this.resetDestino('ocupacao')
            if (!value) return
            const infraestrutura = this.form.destino.infraestruturas.find(item => item.id == value)
            this.model.destino.prestadorInternoId = infraestrutura ? infraestrutura.prestadorInternoId : null
            this.setLoading()
            try {
                const {data} = await this.repositories.reagendamentoMedico.list(this.camelObjectKeysToSnakeRecursive(
                    this.destinoParams({listar: 'ocupacoes', infraestruturaId: value})
                ))
                this.form.destino.ocupacoes = data.ocupacoes
                this.form.destino.especialidades = data.especialidades
            } catch (exception) {
                this.handleError(exception)
            } finally {
                this.unsetLoading()
            }
        },
        async changeDestinoOcupacao(value) {
            this.resetDestino('usuario')
            if (!value) return
            this.setLoading()
            try {
                const {data} = await this.repositories.reagendamentoMedico.list(this.camelObjectKeysToSnakeRecursive(
                    this.destinoParams({
                        listar: 'usuarios',
                        infraestruturaId: this.model.destino.infraestruturaId,
                        ocupacaoId: value,
                    })
                ))
                this.form.destino.usuarios = data.usuarios
            } catch (exception) {
                this.handleError(exception)
            } finally {
                this.unsetLoading()
            }
        },
        async changeDestinoUsuario(value) {
            this.model.destino.jornadaId = null
            this.form.destino.jornadas = []
            if (!value) return
            await this.loadJornadas()
        },
        async loadJornadas() {
            this.setLoading()
            try {
                const {data} = await this.repositories.reagendamentoMedico.list(this.camelObjectKeysToSnakeRecursive(
                    this.destinoParams({
                        listar: 'jornadas',
                        infraestruturaId: this.model.destino.infraestruturaId,
                        ocupacaoId: this.model.destino.ocupacaoId,
                        usuarioId: this.model.destino.usuarioId,
                    })
                ))
                this.form.destino.jornadas = data.jornadas
            } catch (exception) {
                this.handleError(exception)
            } finally {
                this.unsetLoading()
            }
        },
        resetDestino(level = 'unidade') {
            const fields = ['unidade', 'infraestrutura', 'ocupacao', 'usuario', 'jornada']
            const collections = {
                unidade: 'unidades',
                infraestrutura: 'infraestruturas',
                ocupacao: 'ocupacoes',
                usuario: 'usuarios',
            }
            fields.slice(fields.indexOf(level)).forEach(field => {
                this.model.destino[`${field}Id`] = null
                if (field !== 'jornada') this.form.destino[collections[field]] = []
            })
            if (['unidade', 'infraestrutura'].includes(level)) this.model.destino.prestadorInternoId = null
            this.form.destino.jornadas = []
        },
        async prepareSameDestination() {
            this.resetDestino()
            this.model.destino.unidadeId = this.model.origem.unidadeId
            await this.changeDestinoUnidade(this.model.destino.unidadeId)
            const infraestrutura = this.form.destino.infraestruturas.find(item => item.id == this.model.origem.infraestruturaId)
            if (!infraestrutura) {
                this.showWarningNotification('A origem não está habilitada como prestador interno para esta especialidade.')
                return
            }
            this.model.destino.infraestruturaId = infraestrutura.id
            this.model.destino.prestadorInternoId = infraestrutura.prestadorInternoId
            this.model.destino.ocupacaoId = this.model.origem.ocupacaoId
            this.model.destino.usuarioId = this.model.origem.usuarioId
            await this.loadJornadas()
        },
        jornadaCompativel(jornada) {
            const consultas = this.selected.some(item => item.tipoId === agendamentoTipo.CONSULTA)
            const retornos = this.selected.some(item => item.tipoId === agendamentoTipo.RETORNO)
            return (!consultas || jornada.quantidadeConsultaTotal > 0)
                && (!retornos || jornada.quantidadeRetornoTotal > 0)
        },
        getExcess() {
            const jornada = this.form.destino.jornadas.find(item => item.id == this.model.destino.jornadaId)
            if (!jornada) return 0
            const consultas = this.selected.filter(item => item.tipoId === agendamentoTipo.CONSULTA).length
            const retornos = this.selected.filter(item => item.tipoId === agendamentoTipo.RETORNO).length
            return Math.max(0, consultas - (jornada.quantidadeConsultaTotal - jornada.quantidadeConsultaAgendada))
                + Math.max(0, retornos - (jornada.quantidadeRetornoTotal - jornada.quantidadeRetornoAgendada))
        },
        confirmOperation() {
            if (this.selected.length > this.additionals.limiteAgendamentos) {
                this.showWarningNotification(`Selecione no máximo ${this.additionals.limiteAgendamentos} consultas.`)
                return
            }
            const jornada = this.form.destino.jornadas.find(item => item.id == this.model.destino.jornadaId)
            if (!jornada || !this.jornadaCompativel(jornada)) {
                this.showWarningNotification('A jornada selecionada não é compatível com os tipos de consulta selecionados.')
                return
            }
            this.$refs.operationForm.validate().then(valid => {
                if (!valid) return
                const excess = this.getExcess()
                if (excess > 0) {
                    this.showConfirmation(
                        `${excess} consulta(s) excedem as vagas. Deseja reagendar todas como encaixe?`,
                        () => this.openSupervisor(true),
                        () => this.openSupervisor(false)
                    )
                } else {
                    this.openSupervisor(false)
                }
            })
        },
        openSupervisor(authorizeFit) {
            this.model.autorizaEncaixe = authorizeFit
            this.$refs.supervisor.open()
        },
        async process(supervisor) {
            this.submitting = true
            this.setLoading()
            try {
                const request = {
                    origem: this.model.origem,
                    agendamentos: this.selected.map(item => item.id),
                    jornadaId: this.model.destino.jornadaId,
                    prestadorInternoId: this.model.destino.prestadorInternoId,
                    motivoReagendamento: this.model.motivoReagendamento,
                    autorizaEncaixe: this.model.autorizaEncaixe,
                    supervisor,
                }
                const {data} = await this.repositories.reagendamentoMedico.store(
                    this.camelObjectKeysToSnakeRecursive(request)
                )
                this.$refs.supervisor.close()
                this.resultado = data
                if (data.quantidadeNaoReagendada > 0) {
                    this.showWarningNotification(
                        'O reagendamento foi concluído com consultas não reagendadas. Consulte os motivos no resultado.'
                    )
                } else {
                    this.showSaveNotification()
                }
                await this.refreshAfterProcessing()
            } catch (exception) {
                const response = exception.response
                const message = response && response.data && response.data.message

                if (response && response.status === 422 && typeof message === 'string' && message) {
                    this.showValidationNotification(message)
                } else {
                    this.handleError(exception)
                }
            } finally {
                this.submitting = false
                this.unsetLoading()
            }
        },
        async refreshAfterProcessing() {
            const dataOrigem = this.model.origem.data

            await this.loadOrigem('datas')

            const dataAindaDisponivel = this.form.origem.datas.some(item => item.data === dataOrigem)

            this.mesmoDestino = null
            this.todosSelecionados = false
            this.model.motivoReagendamento = null
            this.model.autorizaEncaixe = false
            this.resetDestino()

            if (dataAindaDisponivel) {
                this.model.origem.data = dataOrigem
                await this.loadAppointments()
                await this.loadDestinoUnidades()
                return
            }

            this.model.origem.data = null
            this.form.origem.agendamentos = []
        },
        resetOperation() {
            this.mesmoDestino = null
            this.todosSelecionados = false
            this.resultado = null
            if (this.model) {
                this.model.motivoReagendamento = null
                this.model.autorizaEncaixe = false
                this.resetDestino()
            }
        },
    },
    mixins: [error, repository, stringCase],
    mounted() { this.load() },
    props: {id: {type: Number, required: true}},
    watch: {
        mesmoDestino(value) {
            if (value === true) this.prepareSameDestination()
            if (value === false) {
                this.resetDestino()
                this.loadDestinoUnidades()
            }
        },
    },
}
</script>
